module.exports = __webpack_public_path__ + "media/assets/faria_products/MB_PASSPORT-4744adbcee4461a20e7f3bf27378a292cca2e664a23e0632a393aeeaef646d24.png";